<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-6">
        <h4 class="f-bold pt-2 pl-3 cl-primary text-left">Data Customer</h4>
      </div>
      <div class="col-12 col-md-6">
        <nav aria-label="breadcrumb">
          <ol
            class="breadcrumb float-right"
            style="background-color: transparent"
          >
            <li class="breadcrumb-item">
              <router-link to="/admin/dashboard">Dashboard</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Data Customer
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="table-responsive">
      <div class="d-flex justify-content-around" v-if="loading">
        <loader-component></loader-component>
      </div>

      <table class="table table-bordered table-hover" v-if="!loading">
        <thead class="thead-light">
          <tr>
            <th scope="col">No</th>
            <th scope="col">Nama</th>
            <th scope="col">Email</th>
            <th scope="col">Phone</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="data.length == 0">
            <td colspan="7">Customer is Empty</td>
          </tr>
          <tr v-for="(banner, p) in data" :key="p">
            <th scope="row">{{ p + 1 }}</th>
            <td>{{ banner.name }}</td>
            <td>{{ banner.email }}</td>
            <td>{{ banner.telephone }}</td>
            <td>
              <div class="d-flex justify-content-around">
                <p
                  style="cursor: pointer"
                  class="btn btn-link"
                  @click.prevent="detailCustomer(banner.id)"
                >
                  <span class="material-icons"> launch </span>
                </p>
                <!-- <p
                  style="cursor: pointer"
                  class="btn btn-link"
                  @click.prevent="deleteBanner(banner.id)"
                >
                  <span class="material-icons"> delete </span>
                </p> -->
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import LoaderComponent from "../../components/Loader.vue";
export default {
  name: "Banner",
  components: { LoaderComponent },
  data() {
    return {
      loading: true,
      data: [],
    };
  },

  mounted() {
    this.getAllCustomer();
  },

  methods: {
    getAllCustomer() {
      this.loading = true;
      const endpoint = "customer-list";
      this.$api.get(endpoint, (status, data, message) => {
        if (status === 200) {
          this.loading = false;
          this.data = data.customer_list;
          console.log(this.data);
        } else {
          this.loading = false;
          console.log(message);
        }
      });
    },

    bannerForm() {
      this.$router.push("/admin/banners/add");
    },

    deleteBanner(id) {
      Vue.swal({
        title: "Are you sure?",
        text: "This banner will be delete",
        icon: "question",
        showCancelButton: true,
        cancelButtonColor: "#eb4d4b",
        confirmButtonText: "Yes, Delete!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          const endpoint = `banner/${id}`;
          this.$api.delete(endpoint, (status, data, message) => {
            if (status === 200) {
              this.loading = false;
              Vue.swal("Success", "Banner deleted", "success").then(() => {
                this.getAllCustomer();
              });
            } else {
              this.loading = false;
              console.log(message);
            }
          });
        }
      });
    },

    detailCustomer(id) {
      this.$router.push(`/admin/customer-list/detail/${id}`);
    },
  },
};
</script>
